import { render, staticRenderFns } from "./LgFinderPageEspecificacaoProdutoAlmoxarifado.vue?vue&type=template&id=0e8c97e8"
import script from "./LgFinderPageEspecificacaoProdutoAlmoxarifado.vue?vue&type=script&lang=js"
export * from "./LgFinderPageEspecificacaoProdutoAlmoxarifado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports